import { FC } from 'react';

type Props = {
    content: string;
};

const DepthTracking: FC<Props> = ({ content }: Props) => {
    return <span data-wa-depth={content} />;
};

export default DepthTracking;
